import { IonButton } from '@ionic/react';
import React from 'react'
import { useHistory } from 'react-router';
import { API_URL } from '../../actions/settings';
import AddCustomerButton from '../AE2/AddCustomerButton';

async function logout(token: string) {
  return fetch(`${API_URL}/logout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
    if (res.ok) {
      return true;
    } else {
      return false;
    }
  });
}


const Logout = () => {
    const history = useHistory()
    const year = new Date().getFullYear();

    const handleLogout = async () => {
      const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
      await logout(token)
      localStorage.clear();
      history.push("/login");
      window.location.reload()
    };

    const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';

    if(newUI){
      return <div className='logout-button'>        
          <IonButton  expand='block' color='medium' onClick={handleLogout}>Logout</IonButton>
        </div>
    }
  return (
  <div className='logout-button'>
        <AddCustomerButton/>
        <IonButton  expand='block' color='medium' onClick={handleLogout}>Logout</IonButton>
        <div>Copyright © 2019 - {year}</div>
        <div>Alpha Controls & Services, LLC All Rights Reserved.</div>
        <a href="/terms_and_conditions" target="_blank">Terms & Conditions</a> - <a href="/privacy" target="_blank"> Privacy Policy </a>
        </div>)
}

export default Logout